import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ReactComponent as AssociateEventsIcon } from "../../assets/img/Sidebar/associate-events.svg";
import { dashboardColors } from "../../themes/Theme";
import OrganiserDetails from "../../revampPages/ManageEvents/EventProfileDetails/OrganiserDetails";
import Team from "../../revampPages/ManageEvents/EventProfileDetails/Team";
import WhiteLabel from "../../revampPages/ManageEvents/EventProfileDetails/WhiteLabel";
import AssociatedEvents from "../../revampPages/ManageEvents/EventProfileDetails/AssociatedEvents";

const useEventProfileSidebarItems = () => {
    const { profileId } = useParams();

    return [
        {
            path: `/event-profile/${profileId}/organizer-details`,
            label: "Organiser Details",
            icon: (
                <div className="sidebar-item">
                    <Icon
                        icon="hugeicons:identity-card"
                        height="22px"
                        width="22px"
                        style={{ color: dashboardColors.light.iconColor }}
                    />
                </div>
            ),
            component: OrganiserDetails,
        },
        {
            path: `/event-profile/${profileId}/team`,
            label: "Team",
            icon: (
                <div className="sidebar-item">
                    <Icon
                        icon="hugeicons:add-team"
                        height="22px"
                        width="22px"
                        style={{ color: dashboardColors.light.iconColor }}
                    />
                </div>
            ),
            component: Team,
        },
        {
            path: `/event-profile/${profileId}/white-label`,
            label: "White Label",
            icon: (
                <div className="sidebar-item">
                    <Icon
                        icon="tabler:brush"
                        height="22px"
                        width="22px"
                        style={{ color: dashboardColors.light.iconColor }}
                    />
                </div>
            ),
            component: WhiteLabel,
        },
        {
            path: `/event-profile/${profileId}/associated-events`,
            label: "Associated Events",
            icon: (
                <div className="sidebar-item">
                    <AssociateEventsIcon width="22" height="22" />
                </div>
            ),
            component: AssociatedEvents,
        },
    ];
};

export default useEventProfileSidebarItems;